package co.uk.sacursoftware.ssinventory.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.ImageBitmap
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import co.uk.sacursoftware.ssinventory.util.ImageCache

@Composable
fun RemoteImageView(
    url: String,
    modifier: Modifier = Modifier,
    contentScale: ContentScale = ContentScale.Fit,
    imageId: String? = null
) {
    var imageBitmap by remember(url, imageId) { mutableStateOf<ImageBitmap?>(ImageCache.peek(url, imageId)) }
    var hasError by remember(url, imageId) { mutableStateOf(false) }

    LaunchedEffect(url, imageId) {
        if (url.isBlank()) {
            hasError = true
            return@LaunchedEffect
        }
        try {
            imageBitmap = ImageCache.load(url, imageId)
            hasError = false
        } catch (_: Throwable) {
            if (imageBitmap == null) hasError = true
        }
    }

    if (imageBitmap != null) {
        Image(
            bitmap = imageBitmap!!,
            contentDescription = "Photo",
            modifier = modifier,
            contentScale = contentScale
        )
    } else if (hasError) {
        Box(modifier = modifier, contentAlignment = Alignment.Center) {
            Text("Failed to load image", style = MaterialTheme.typography.bodySmall, color = MaterialTheme.colorScheme.error)
        }
    } else {
        Box(modifier = modifier, contentAlignment = Alignment.Center) {
            CircularProgressIndicator(modifier = Modifier.size(36.dp))
        }
    }
}
